module.exports = __webpack_public_path__ + "static/media/face4ok.994729b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/FeedbackForm/images/face4ok.svg
// module id = 1219
// module chunks = 2